import React, { Component } from 'react';
import { connect } from 'react-redux';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { showError, showSnackbar } from 'actions/CommonActions';
import { syncFromCatalog } from 'actions/EntityActions';
import Button from 'screens/components/basic/Button';
import "../Styles/productList.styles.css"

class ToggleButtonGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
      toggleModel: {
        BranchId: props.branchId,
        SKU: this.props.productSKU ? this.props.productSKU : "",
        UPC: false,
        Description: false,
        SubCategory: false,
        Brand: false,
        Terpene: false,
        THCCBDRange: false,
        DFE: false,
        ImportImageURL: false,
        Species: false,
        NumberOfItems: false,
        Size: false,
        ForceUpdate: false
      }
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.productSKU !== this.props.productSKU) {
      this.setState(prevState => ({
        ...prevState,
        toggleModel: {
          ...prevState.toggleModel,
          SKU: this.props.productSKU ? this.props.productSKU : ""
        }
      }));
    }

    if ((prevProps.syncProductSuccess === null && this.props.syncProductSuccess !== null) || prevProps.syncProductSuccess !== this.props.syncProductSuccess) {
      this.handleTogglePopup()
      this.props.showSuccess("Sync From Master Catalog Success")
    }

    if ((prevProps.syncProductfail === null && this.props.syncProductfail !== null) || prevProps.syncProductfail !== this.props.syncProductfail) {
      this.handleTogglePopup()
      this.props.showError(`Could not update product information. ${this.props.syncProductfailError}.`)
    }

  }

  handleTogglePopup = () => {
    this.setState((prevState) => ({
      showPopup: !prevState.showPopup
    }));
  };

  handleToggle = (e) => {
    const toggleName = e.target.name
    const toggleValue = e.target.checked;
    this.setState(prevState => ({ ...prevState, toggleModel: { ...prevState.toggleModel, [toggleName]: toggleValue } }))
  }

  handleToggleCancel = () => {
    this.setState(prevState => ({
      ...prevState, toggleModel: {
        BranchId: this.props.branchId,
        SKU: this.props.productSKU ? this.props.productSKU : "",
        UPC: false,
        Description: false,
        SubCategory: false,
        Brand: false,
        Terpene: false,
        THCCBDRange: false,
        DFE: false,
        ImportImageURL: false,
        Species: false,
        NumberOfItems: false,
        Size: false,
        ForceUpdate: false
      }
    }))
  }

  checkAllFalse = (toggleModel) => {
    for (const key in toggleModel) {
      if (toggleModel.hasOwnProperty(key) && toggleModel[key] === true) {
        return false;
      }
    }
    return true;
  }

  handleSubmit = () => {
    if (!this.checkAllFalse(this.state.toggleModel)) {
      this.props.syncFromCatalog(this.state.toggleModel);
    }
  }

  render() {
    const toggleOptions = [
      { name: "UPC", label: "UPC" },
      { name: "Description", label: "Description" },
      { name: "SubCategory", label: "Sub Category" },
      { name: "Brand", label: "Brand" },
      { name: "Terpene", label: "Terpene" },
      { name: "THCCBDRange", label: "THC/CBD Range" },
      { name: "DFE", label: "DFE" },
      { name: "ImportImageURL", label: "Import Image" },
      { name: "Species", label: "Species" },
      { name: "NumberOfItems", label: "Number Of Items" },
      { name: "Size", label: "Item Size" }
    ];
    const p = this.props
    const updateAllWarn = this.state.toggleModel.SKU === "" ? true : false
    const forceUpdate = this.state.toggleModel.ForceUpdate
    return (
      <div className="button-popup-container" style={p.containerStyle}>
        <Button
          style={{ margin: "3px 5px" }}
          type="ImportExportButton"
          buttonStyle={p.mainButtonStyle}
          label="Sync From Catalog"
          id="syncFromCatalogButton"
          className={`primary-color-bg ${p.customClassName}`}
          onTouchTap={this.handleTogglePopup}
        />
        {this.state.showPopup ? (
          <div className="popup">
            <div className="popup-arrow"></div>
            <div className="popup-arrow-inner"></div>
            <div className="popup-body"></div>
            {toggleOptions.map((toggleOption, i) => (
              <FormControlLabel
                key={toggleOption.name}
                control={
                  <Switch
                    checked={this.state.toggleModel[toggleOption.name]}
                    onChange={this.handleToggle}
                    name={toggleOption.name}
                    color="primary"
                  />
                }
                label={toggleOption.label}
                style={{ marginBottom: "6px" }}
                labelPlacement="end"
              />

            ))}
            <div className={forceUpdate ? "forceUpdateTooltip" : ""}>
              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.toggleModel["ForceUpdate"]}
                    onChange={this.handleToggle}
                    name="ForceUpdate"
                  />
                }
                label="Force Update"
              />
            </div>
            <Button
              style={{ margin: "3px 5px" }}
              label="Reset"
              buttonStyle={{ backgroundColor: "#eeeded" }}
              onTouchTap={this.handleToggleCancel}
            />
            <Button
              style={{ margin: "3px 5px" }}
              type="RaisedButton"
              label="Submit"
              className="primary-color-bg btnNewBrandPOS"
              onTouchTap={this.handleSubmit}
            />
            {updateAllWarn && <h6 className="warnText">Syncing all products from master catalog may take up to 30 mins.</h6>}
          </div>
        ) : null}
      </div>
    );
  }
}
function mapStatetoProps(state) {
  return {
    branchId: state.common.branchId,
    productSKU: state.form.ProductSaveSKU,
    syncProductSuccess: state.entity.syncProductsInfoTime,
    syncProductfail: state.entity.syncProductsInfoErrorTime,
    syncProductfailError: state.entity.syncProductsInfoError
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showError: (message) => dispatch(showError(message)),
    showSuccess: (message) => dispatch(showSnackbar(message)),
    syncFromCatalog: (model) => dispatch(syncFromCatalog(model))
  };
}

export default connect(mapStatetoProps, mapDispatchToProps)(ToggleButtonGroup)
